// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-file {
    padding: 0 8px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    gap: 4px;
    flex-basis: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.breadcrumb-item:not(:last-child) {
    cursor: pointer;
}

.breadcrumb-item-icon em {
    font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/bread-crumb-file.css"],"names":[],"mappings":"AAAA;IACI,cAAc;;IAEd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;;IAEf,QAAQ;IACR,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".breadcrumb-file {\n    padding: 0 8px;\n\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-wrap: wrap;\n\n    gap: 4px;\n    flex-basis: 50%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.breadcrumb-item:not(:last-child) {\n    cursor: pointer;\n}\n\n.breadcrumb-item-icon em {\n    font-size: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
